module.exports = __webpack_public_path__ + "img/list22.476d7222.jpeg";